import { Link } from "react-router";
import { PublicPageLayout } from "@/components/PublicPageLayout";

const TEXT_LINK =
  "font-medium text-[var(--cs-navy)] underline decoration-[#AFC2D0] underline-offset-4 transition-colors hover:decoration-[var(--cs-navy)]";

const CONTACT_TOPICS = [
  {
    title: "Starten met Carmen",
    body: "Hulp bij installatie, configuratie en onboarding.",
  },
  {
    title: "Product en workflow",
    body: "Bespreek dictatie, consultnotities, vertaling en uw workflow.",
  },
  {
    title: "Privacy en beveiliging",
    body: "Vraag documentatie voor privacy, security, DPA of DPIA.",
  },
];

export function ContactPage() {
  return (
    <PublicPageLayout>
      <article className="mx-auto w-full max-w-[900px] text-[var(--cs-navy)]">
        <header className="pb-10 sm:pb-14">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#738093]">
            Contact
          </p>
          <h1 className="mt-4 max-w-[760px] text-[42px] font-semibold leading-[1.04] tracking-[-0.04em] sm:text-[58px]">
            Vertel ons hoe uw zorgteam werkt.
          </h1>
          <p className="mt-8 max-w-[790px] text-[17px] leading-8 text-[#536274]">
            Vragen over Carmen, implementatie of beveiliging? Neem contact met ons op.
          </p>
        </header>

        <section className="border-t border-[#DCE4EA] py-9 sm:py-11">
          <div className="grid gap-5 md:grid-cols-[200px_minmax(0,1fr)] md:gap-10">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#738093]">
                01
              </p>
              <h2 className="mt-2 text-[24px] font-semibold leading-tight tracking-[-0.02em]">
                Waarmee kunnen we helpen?
              </h2>
            </div>
            <div className="grid gap-6 sm:grid-cols-3">
              {CONTACT_TOPICS.map((topic) => (
                <div key={topic.title}>
                  <h3 className="text-[15px] font-semibold text-[var(--cs-navy)]">
                    {topic.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-6 text-[#647286]">{topic.body}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="border-t border-[#DCE4EA] py-9 sm:py-11">
          <div className="grid gap-5 md:grid-cols-[200px_minmax(0,1fr)] md:gap-10">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#738093]">
                02
              </p>
              <h2 className="mt-2 text-[24px] font-semibold leading-tight tracking-[-0.02em]">
                Stuur een e-mail
              </h2>
            </div>
            <div className="space-y-6 text-[15px] leading-7 text-[#536274]">
              <p>
                U bereikt Carmen via{" "}
                <a href="mailto:info@askcarmen.eu" className={TEXT_LINK}>
                  info@askcarmen.eu
                </a>
                . Vermeld uw rol, organisatie en vraag.
              </p>
              <a
                href="mailto:info@askcarmen.eu"
                className="inline-flex items-center justify-center rounded-full bg-[var(--cs-navy)] px-5 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-[var(--cs-navy-strong)]"
              >
                Mail Carmen
              </a>
            </div>
          </div>
        </section>

        <section className="border-t border-[#DCE4EA] py-9 sm:py-11">
          <div className="grid gap-5 md:grid-cols-[200px_minmax(0,1fr)] md:gap-10">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#738093]">
                03
              </p>
              <h2 className="mt-2 text-[24px] font-semibold leading-tight tracking-[-0.02em]">
                Documentatie
              </h2>
            </div>
            <div className="space-y-4 text-[15px] leading-7 text-[#536274]">
              <p>
                Bekijk het{" "}
                <Link to="/trust" className={TEXT_LINK}>
                  Trust Center
                </Link>{" "}
                voor beveiligingsinformatie en het{" "}
                <Link to="/privacy" className={TEXT_LINK}>
                  privacybeleid
                </Link>{" "}
                voor gegevensverwerking.
              </p>
            </div>
          </div>
        </section>
      </article>
    </PublicPageLayout>
  );
}
